/*
modificacion 26/5/2018 alcaab:
1 -routingUrl ahora es opcional lo cual permite indica que si es undefined esta en modalidad modal.
2 -modalForm es un function modalFormCallback(accion:'show' |Â´hideÂ´): ahora invocar el modal es mas seguro porque no depende de ninguna clase especifica
con un metodo o clase especial. Simplemente se dispara una funciÃ³n callback cuando se invoca la modalidad dialogo.
*/
import {
  ModalFormService,
  ModalFormRef
} from "./components/form-template/modal-form.service";
import {
  Router,
  ActivatedRoute,
  NavigationExtras,
  UrlTree
} from "@angular/router";
import {
  Injector,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef
} from "@angular/core";
import {
  ModalOption,
  ModalTriggerOpts,
  INavigateAction,
  NavigateOptions,
  BlockerManager
} from "./helpers/modal-option";
import { MsgBoxService } from "./components/msgbox/msgbox.service";
import { appInjector } from "./helpers/app-injector";
import { NavigationMode, TriggerAction, ModelState } from "./helpers/enums";
import { ServiceManager, ServiceSubscriber } from "./service-manager";
import { IManagerOptions, IServiceMethods } from "./interfaces/utils.interface";
import { IMsgBoxEventArgs } from "./components/msgbox/msgbox.interfaces";
import { DialogResult } from "./components/msgbox/msgbox.helper";

export class ComponentManager<T> implements IServiceMethods, OnInit, OnDestroy {
  private _modalOpts = new ModalTriggerOpts();
  private _activeNavigation: NavigationMode = NavigationMode.Default;
  private _injector: Injector = appInjector();
  private _route: ActivatedRoute = this._injector.get(ActivatedRoute);
  private _msgbox: MsgBoxService = this._injector.get(MsgBoxService);
  private _modalRef: ModalFormRef;
  private _serviceSubscriber: ServiceSubscriber;
  modalMode: boolean;
  modalOptions = new ModalOption();
  disableRoutingAndModal = false;
  skipLocationChange = true;
  router: Router = this._injector.get(Router);

  @ViewChild("modalContent")
  modalContent: string | TemplateRef<any> | any;

  navigateOptions: NavigateOptions = {
    add: {
      openWith: NavigationMode.Default,
      route: ["/add"]
    },
    edit: {
      openWith: NavigationMode.Default,
      route: ["/edit"]
    },
    added: {
      route: []
    },
    edited: {
      route: []
    },
    default: [],
    set(action: string, options: INavigateAction) {
      if (!this[action]) {
        throw Error("action do not exist");
      }

      this[action] = Object.assign({}, this[action], options);
    }
  };
  /**
   * @property {boolean} askBeforeDelete : activa o desactiva el dialogo de confirmaciÃ³n al ejecutar delete via ServiceManager.delete.
   * Valor por defecto (true)
   */
  askBeforeDelete = true;
  scrollTopOnInit = true;
  showSearchBar = true;
  /**
   * @property {boolean} loadDataOnInit : activa o desactiva la carga de datos que se ejecuta del ServiceManager.refresh al iniciar el componente.
   * Valor por defecto (true)
   */
  loadDataOnInit = true;
  get blocker(): BlockerManager {
    return this.dataService.blocker;
  }

  /**
   * @readonly
   * @property {boolean} loading : indica cuando el servicio de datos inicia una peticion (true) y cuando recibe respuesta (false) del servidor.
   */

  get loading(): boolean {
    return this.dataService.state == ModelState.Loading;
  }

  /**
   * @property {number} dataInitializationDelay : entero que representa los milisengundos
   * que tardara el ComponentManager en hacer la peticiÃ³n inicial al servidor para la carga de datos. Valor por defecto (5)
   */
  dataInitializationDelay = 5;

  modalFormService?: ModalFormService;

  constructor(
    public dataService: ServiceManager<T>,
    public routingUrl?: string
  ) {
    this.dataService.callerComponent.host = 'manager';
    this.modalMode = !routingUrl;
    this._serviceSubscriber = new ServiceSubscriber(dataService, this);
    this._serviceSubscriber.subscribe();
    this.dataService.componentManager = this;
    /*
		El servicio de busqueda controla el search bar de la aplicacion
		*/
  }

  setOptions(options: IManagerOptions) {
    Object.assign(this, options);
  }

  /// llamar este metodo en la clase hija para inicializar el padre (super.ngOnInit())
  ngOnInit() {

    this.dataService.callerComponent.state = 'initializing';
    if (this.scrollTopOnInit) {
      window.scrollTo(0, 0);
    }

    if (!this.dataService.requestSetting.Page.VirtualPagination) {
      /**
     LA PAGINACION CON EL VIRTUAL SCROLL DEL TABLE DE PRIMENG DISPARA EL EVENTO LAZYLOAD AUTOMATICAMENTE AL INICIAL EL
     COMPONENT ESTA VALIDACION ES PARA EVITAR QUE COMPORTAMIENTOS DE ESTE TIPO ENVIEN DOS PEDIDOS AL SERVIDOR
     */
      setTimeout(
        () => this.dataService.refresh(),
        this.dataInitializationDelay
      );
    }
  }

  ngOnDestroy() {
    this.dataService.callerComponent.state = 'destroying';
    this._serviceSubscriber.unsubscribe();
  }

  setModalContent(content: string | TemplateRef<any> | any) {
    this.modalContent = content;
  }

  onLoad(args?: any) { }

  onModal(args: ModalTriggerOpts) {
    if (!this.modalFormService) throw Error("No modal service defined");

    if (args.action == TriggerAction.open) {
      if (!this.modalOptions) {
        this.modalOptions = new ModalOption();
      }

      this._modalRef = this.modalFormService.show(
        this.modalContent,
        this.modalOptions
      );
      this._modalRef.setComponentManager(true);
    } else {
      this._modalRef.hide();
    }
  }

  onAdd(args?: any) {
    if (!this.disableRoutingAndModal) {
      if (
        this.navigateOptions.add.openWith == NavigationMode.Modal ||
        this.modalMode
      ) {
        this._activeNavigation = NavigationMode.Modal;

        if (!this._modalOpts.IsShown) {
          this.onModal(
            this._modalOpts.set(TriggerAction.open, false, args.model)
          );
        }
      } else {
        this._activeNavigation = NavigationMode.Routing;

        let navigationExtras: NavigationExtras;
        if (this.dataService.identityPropertyName) {
          navigationExtras = {
            queryParams: { id: this.dataService.identityValue }
          };
        }
        this.internalNavigate(
          this.navigateOptions.edit.route,
          navigationExtras
        );
      }
    }
  }

  onAdded(args?: any) {
    if (this.dataService.saveAndKeep) {
      return;
    }
    // no dispara el evento si deseamos quedarmos para agreagar uno nuevo
    if (this.dataService.saveAndNew) {
      this.dataService.add();
      return;
    }

    if (!this.disableRoutingAndModal) {
      if (this._activeNavigation == NavigationMode.Modal) {
        if (this._modalOpts.IsShown) {
          this.onModal(
            this._modalOpts.set(TriggerAction.close, false, args.model)
          );
        }
      } else {
        this.internalNavigate(this.navigateOptions.added.route);
      }
    }

    this._activeNavigation = NavigationMode.Default;
  }

  get isEditRouting(): boolean {

    const url = this.absoluteRouting(this.navigateOptions.edit.route[0]);
    return this._route.snapshot.url.join('').includes(url);

  }

  onEdit(args?: any) {
    if (!this.disableRoutingAndModal) {
      if (
        this.navigateOptions.edit.openWith == NavigationMode.Modal ||
        this.modalMode
      ) {
        this._activeNavigation = NavigationMode.Modal;

        if (!this._modalOpts.IsShown) {
          this.onModal(this._modalOpts.set(TriggerAction.open));
        }
      } else {
        this._activeNavigation = NavigationMode.Routing;
        let navigationExtras: NavigationExtras;
        if (this.dataService.identityPropertyName) {
          navigationExtras = {
            queryParams: { id: this.dataService.identityValue }
          };
        }
        this.internalNavigate(
          this.navigateOptions.edit.route,
          navigationExtras
        );
      }
    }
  }

  onEdited(args?: any) {
    if (!this.disableRoutingAndModal) {
      if (this._activeNavigation == NavigationMode.Modal) {
        if (this._modalOpts.IsShown && !this.dataService.saveAndKeep) {
          this.onModal(this._modalOpts.set(TriggerAction.close));
        }
      } else {
        this.internalNavigate(this.navigateOptions.edited.route);
      }
    }

    this._activeNavigation = NavigationMode.Default;
  }

  onDelete(args: any) {
    if (this.askBeforeDelete) {
      this._msgbox.confirmDelete({
        callback: (evt: IMsgBoxEventArgs) => {
          if (evt.result == DialogResult.Yes) {
            this.dataService.post();
          } else {
            this.dataService.cancel();
          }
        }
      });
    } else {
      this.dataService.post();
    }
  }

  onDeleted(args?: any) { }

  onStateChange(state?: any) { }

  onSettingRefreshed(args?: any) { }

  onCancel(args: any) {
    this.dataService.stateChange(ModelState.Canceled, ModelState.Browse);

    if (this._activeNavigation == NavigationMode.Modal) {
      this.onModal(this._modalOpts.set(TriggerAction.close, true));
    } else {
      this.internalNavigate(this.navigateOptions.default);
    }

    this._activeNavigation = NavigationMode.Default;
  }

  internalNavigate(commands: any[], extras?: NavigationExtras) {
    const _commands = commands.slice();

    if (_commands.length > 0) {
      _commands[0] = this.absoluteRouting(_commands[0]);
    } else {
      _commands.push(this.routingUrl);
    }

    if (!extras) {
      extras = {};
    }
    const extrs = Object.assign(extras, {
      relativeTo: this._route,
      skipLocationChange: this.skipLocationChange
    });

    return this.router.navigate(_commands, extrs);
  }

  /*solo para exponer algunas funcionalidades que el programdor prodrÃ­a necesitar para
	customizar el componente*/
  navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    return this.router.navigate(commands, extras);
  }

  navigateByUrl(
    url: string | UrlTree,
    extras?: NavigationExtras
  ): Promise<boolean> {
    return this.router.navigateByUrl(url, extras);
  }

  absoluteRouting(fragment?: string) {
    if (!this.routingUrl) {
      throw Error("no urlRouting");
    }

    if (!fragment) {
      return this.routingUrl;
    }

    return this.routingUrl.concat(fragment);
  }
}
